import { default as messageAntd } from 'antd/es/message';

export function message(): typeof messageAntd {
  return messageAntd;
}
